module.exports = __webpack_public_path__ + "img/azure-icon.660faf36.svg";